// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ud_X","questions":"styles_questions__1k_cQ","footer":"styles_footer__1KNI2"};